import { IRootState } from '../../app/store';

export const selectSaveSkillViewAsyncStatus = (state: IRootState) =>
    state.skillLaunch.asyncStatus;
export const selectSaveSkillViewStatusCode = (state: IRootState) =>
    state.skillLaunch.statusCode;
export const selectCourseAsyncStatus = (state: IRootState) =>
    state.skillLaunch.courseAsyncStatus;
export const selectCourseDetails = (state: IRootState) =>
    state.skillLaunch.courseDetails;
export const selectCourseIdByIdentifier = (state: IRootState) =>
    state.skillLaunch.courseIdByIdentifier;
export const selectCourseIdByIdentifierAsyncStatus = (state: IRootState) =>
    state.skillLaunch.courseIdByIdentifierAsyncStatus;
